<template>
<div id="new">
    <div class="clearfix new-top-line">
        <div class="wrapper">
            <div class="col-xs-40 no-padding" style="display: none">
                <a href="new/row.prev/">Предыдущая</a>
            </div>
            <div class="col-xs-40 no-padding"><router-link to="/news/">Все новости</router-link></div>
            <div class="col-xs-40 no-padding" style="display: none">
                <a href="new/row.next/">Следующая</a>
            </div>
        </div>
    </div>
    <div class="info text clearfix new-content">
        <div class="wrapper">
            <div class="col-sm-40 col-xs-120 no-padding" style="padding-right: 0;">
                <div class="img clearfix" :style="[ !post.img ? {background: '#333', height: '400px'} : {background: 'url(' + post.img + ') 0 0 no-repeat', backgroundSize: 'auto', backgroundPosition: 'top center', height: '400px'}]">
                </div>
                <!-- div class="sharebtn">
                    <Go to www.addthis.com/dashboard to customize your tools>
                    <div class="txt">Поделитесь с друзьями!</div>
                    <div class="addthis_inline_share_toolbox"></div>
                </div -->
                </div>
                <div class="col-sm-80 col-xs-120">
                    <div class="wrapper clearfix">
                        <div class="col-xs-120 no-padding">
                            <h1 class="new-h1">{{post.title}}</h1>
                            <div class="date">{{post.date_create}}</div>
                            <v-runtime-template class="text" style="margin-bottom: 90px;" :template="text"/>
                            <div class="comment-form">
                                <form>
                                    <textarea rows="5" placeholder="Оставьте свой комментарий" style="width: 100%;border-radius: 4px;border: 1px solid #ccc;padding: 12px 10px;"></textarea>
                                    <div class="vbtn" style="margin-top: 20px;">Комментировать</div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>
</template>

<script>
import axios from '@/router/http'
import VRuntimeTemplate from 'v-runtime-template'
export default {
  name: 'new',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      post: {},
      text: ''
    }
  },
  created () {
    var id = this.$route.params.id
    axios.get('https://crm.v-avtoservice.com/list/site-new?id=' + id + '&lang=' + this.city.lang + '&city=' + this.city.id).then(response => {
      this.post = response.data
      this.text = '<div>' + response.data.text.replace(/{form_application}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_cat}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_shinomontag}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_avtourist}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_sravni_osago}/gi, '<osago-form/>').replace(/{form_sravni_kasko}/gi, '<kasko-form/>').replace(/{form_sokr}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_karta}/gi, '<texosmotr-form/>').replace(/{/gi, '').replace(/}/gi, '').replace(new RegExp('../../../../frontend/public', 'g'), '/static').replace(new RegExp('../../../frontend/public', 'g'), '/static').replace(new RegExp('../../frontend/public', 'g'), '/static').replace(new RegExp('../frontend/public', 'g'), '/static').replace(new RegExp('frontend/public', 'g'), '/static').replace(new RegExp('../../../../uploads', 'g'), '/static/uploads').replace(new RegExp('../../../uploads', 'g'), '/static/uploads').replace(new RegExp('../../uploads', 'g'), '/static/uploads').replace(new RegExp('../uploads', 'g'), '/static/uploads').replace(new RegExp('uploads', 'g'), '/static/uploads') + '</div>'
    })
  },
  watch: {
    $route (to, from) {
      var id = to.params.id
      axios.get('https://crm.v-avtoservice.com/list/site-new?id=' + id + '&lang=' + this.city.lang + '&city=' + this.city.id).then(response => {
        this.post = response.data
        this.text = '<div>' + response.data.text.replace(/{form_application}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_cat}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_shinomontag}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_avtourist}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_sravni_osago}/gi, '<osago-form/>').replace(/{form_sravni_kasko}/gi, '<kasko-form/>').replace(/{form_sokr}/gi, '<index-form :user.sync="user" :city.sync="city" :auth.sync="auth"/>').replace(/{form_karta}/gi, '<texosmotr-form/>').replace(/{/gi, '').replace(/}/gi, '').replace(new RegExp('../../../../frontend/public', 'g'), '/static').replace(new RegExp('../../../frontend/public', 'g'), '/static').replace(new RegExp('../../frontend/public', 'g'), '/static').replace(new RegExp('../frontend/public', 'g'), '/static').replace(new RegExp('frontend/public', 'g'), '/static').replace(new RegExp('../../../../uploads', 'g'), '/static/uploads').replace(new RegExp('../../../uploads', 'g'), '/static/uploads').replace(new RegExp('../../uploads', 'g'), '/static/uploads').replace(new RegExp('../uploads', 'g'), '/static/uploads').replace(new RegExp('uploads', 'g'), '/static/uploads') + '</div>'
      })
    }
  },
  components: {
    VRuntimeTemplate
  }
}
</script>

<style scoped>
    .new-top-line {padding: 30px 0 20px; background-image: linear-gradient(to bottom, #f0f0f0 0%, #fff 100%);}
    .new-top-line > .wrapper > div{text-decoration: none;  color: #487cc1;  font-weight: 600;}
    .new-top-line > .wrapper > div:nth-child(1){text-align: left;}
    .new-top-line > .wrapper > div:nth-child(2){text-align: center;}
    .new-top-line > .wrapper > div:nth-child(3){text-align: right;}
    .new-h1 {border-top: 1px solid #cccccc;margin: 0;padding: 15px 0 10px;font-size: 18px;font-weight: 600;}
    .new-content .date {
        color: #b2b2b2;
        margin-bottom: 15px;
    }
    .sharebtn .at-share-btn {padding: 4px;margin-left: 5px;}
    .sharebtn {background-color: #f5f5f5;margin-top: 20px;padding: 25px 10px;text-align: center;}
    .sharebtn .txt {font-weight: 600;margin-bottom: 15px;}
</style>



// WEBPACK FOOTER //
// src/components/New.vue